import * as React from 'react'
import ReactMaskInput from 'react-input-mask'
import styled, { css } from 'styled-components'

import CalendarIconImage from '../../../assets/img/calendar-icon.png'

const Control = styled(ReactMaskInput)`
  position: relative;
  width: 100%;
  height: 3rem;
  padding: 0 1rem;
  font-weight: var(--font-weight);

  outline: 0;
  background-color: transparent;

  border-radius: var(--border-radius-form);
  border: var(--border-form);
  transition-property: border-color, opacity;
  transition-duration: var(--animation-duration);
  transition-timing-function: var(--animation-easing);

  ${props =>
    props.hasError &&
    css`
      border-color: var(--color-error);
    `}

  &:disabled {
    opacity: 0.5;
  }

  &:focus {
    border-color: var(--color-primary);
  }

  &::placeholder {
    opacity: 0;
  }

  &:required {
    box-shadow: none !important;
  }
`

const Placeholder = styled.span`
  display: flex;
  align-items: center;
  user-select: none;
  border-radius: var(--border-radius-form);

  color: var(--color-fg-light);
  position: absolute;

  transition-property: font-size, height, background-color, padding, top, color;
  transition-duration: var(--animation-duration);
  transition-timing-function: var(--animation-easing);

  background-color: var(--color-bg-form);
  height: 1rem;
  padding: 0 0.25rem;
  font-size: 0.75em;
  top: -0.5rem;
  left: 0.75rem;
  pointer-events: none;
  overflow-x: visible;
  white-space: nowrap;

  &:empty {
    display: none;
  }

  ${Control}:placeholder-shown ~ & {
    background-color: transparent;
    height: 3rem;
    top: 0;
    padding: 0 0.25rem;
    font-size: 1rem;

    ${({ variant }) =>
      variant === 'small'
        ? css`
            font-size: 0.8rem !important;
            color: var(--color-fg);
          `
        : css`
            font-size: 1rem;
          `}
  }

  ${props =>
    props.hasError &&
    css`
      color: var(--color-error);
      ${Control}:placeholder-shown ~ & {
        color: var(--color-fg-light);
      }
    `}

  ${Control}:focus ~ & {
    background-color: var(--color-bg-form);
    color: var(--color-primary) !important;
    height: 1rem;
    padding: 0 0.25rem;
    font-size: 0.75em;
    top: -0.5rem;
    left: 0.75rem;
  }
`
const IconContainer = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  width: 3rem;
  height: 3rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  height: 3rem;
`
const CalendarIcon = styled.img.attrs({ src: CalendarIconImage })`
  width: 1rem;
  align-self: center;
`

function MaskInput(props) {
  const {
    maskInput,
    dateMask,
    touched,
    error,
    placeholder,
    variant,
    withIcon,
  } = props

  return (
    <>
      <Control
        {...(maskInput ? { mask: dateMask, maskChar: '' } : {})}
        {...props}
      />
      <Placeholder
        touched={touched}
        hasError={touched && error}
        variant={variant}
      >
        {placeholder}
      </Placeholder>
      {withIcon && (
        <IconContainer>
          <CalendarIcon />
        </IconContainer>
      )}
    </>
  )
}

MaskInput.defaultProps = {
  // TODO: specify default props
}

MaskInput.propTypes = {
  // TODO: specify prop types
}

export default MaskInput
